module.exports = __webpack_public_path__ + "static/media/11.8df86883.jpg";